import * as yup from "yup";

const testSchema = yup.object().shape({
  name: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for Package Name")
    .label("Package Name"),
  tests: yup.array().min(1).of(yup.string()).label("Parameter"),
  notes: yup.string().label("Notes"),
  sampleCount: yup
    .number()
    .min(1)
    .label("Sample Count")
    .typeError("Please enter a valid number"),
  commodity: yup.string().required().label("Commodity"),
});
const schema = yup.object().shape({
  pickupRequestDate: yup.string().required().label("Pickup Date"),
  pickupAddress: yup.string().required().label("Pickup Address"),
  billingAddress: yup.string().required().label("Billing Address"),
  user: yup.string().required().label("User Name"),
  company: yup.string().required().label("Company"),
  packages: yup.array().min(1).of(testSchema).required().label("Package"),
});

export default schema;
